import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Alert, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import StatusCotisationJoueur from './statusCotisationJoueur';


function AffichageCotisationJoueur(props) {
  const [cotisation, setCotisation] = useState(null);
  const [configuration,setConfiguration] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;




  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/cotisation/verification/joueur/${props.userData.user.donnée.results[0].id_equipe}/${props.userData.user.donnée.results[0].id}`,
          {
            withCredentials: true // Permet de transmettre les cookies avec la requête
          }
        );
        setCotisation(response.data);
        setIsLoading(false);

        setError(null);
      } catch (error) {
        if (error.response.data.errorType === "COTISATION_NON_CONFIGUREE") {
            setConfiguration(true)
        }
        else if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [apiUrl, props]);



  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }
return (
  <>
    {error && <Alert variant="danger">{error}</Alert>}
    {configuration && 
                  <Modal show={configuration} onHide={() => Navigate('/joueurs/accueil')}>
                    <Modal.Header closeButton>
                    <Modal.Title>Cotisation non configurée</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Le coach de votre équipe n'a pas configuré les cotisations pour votre équipe. Revenez plus tard.
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary"  onClick={() => Navigate('/joueurs/accueil')} >
                       Quitter
                    </Button>
                    </Modal.Footer>
                </Modal>}
    {cotisation && <StatusCotisationJoueur cotisation={cotisation} userData={props.userData}/>}
  </>
);
}

export default AffichageCotisationJoueur;